import { Footer } from "react-bootstrap/lib/Modal";

export const handleMachineVersion = () => {
  let data: dataType = {
    browserName: "Unknown",
    browserVersion: "Unknown",
    OSName: "Unknown",
  };

  let browser_name = "unknown";
  let browser_version = "unknown";
  let OS_name = "Unknown";
  if (window.navigator.userAgent.indexOf("Windows NT 11.0") != -1)
    OS_name = "Windows 11";
  if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1)
    OS_name = "Windows 10";
  if (window.navigator.userAgent.indexOf("Windows NT 6.3") != -1)
    OS_name = "Windows 8.1";
  if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1)
    OS_name = "Windows 8";
  if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1)
    OS_name = "Windows 7";
  if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1)
    OS_name = "Windows Vista";
  if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1)
    OS_name = "Windows XP";
  if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1)
    OS_name = "Windows 2000";
  if (window.navigator.userAgent.indexOf("Mac") != -1) OS_name = "Mac/iOS";
  if (window.navigator.userAgent.indexOf("X11") != -1) OS_name = "UNIX";
  if (window.navigator.userAgent.indexOf("Linux") != -1) OS_name = "Linux";
  if (
    (navigator.userAgent.indexOf("Opera") ||
      navigator.userAgent.indexOf("OPR")) != -1
  ) {
    browser_name = "Opera";
    browser_version = `v${navigator.userAgent.split("Opera/")[1]}`;
  } else if (navigator.userAgent.indexOf("Edg") != -1) {
    browser_name = "Edge";
    browser_version = `v${navigator.userAgent.split("Edg/")[1]}`;
  } else if (navigator.userAgent.indexOf("Chrome") != -1) {
    browser_name = "Chrome";
    browser_version = `v${
      navigator.userAgent.split("Chrome/")[1].split("Safari/")[0]
    }`;
  } else if (navigator.userAgent.indexOf("Safari") != -1) {
    browser_name = "Safari";
    browser_version = `v${navigator.userAgent.split("Safari/")[1]}`;
  } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    browser_name = "Firefox";
    browser_version = `v${navigator.userAgent.split("Firefox/")[1]}`;
  } else if (
    navigator.userAgent.indexOf("MSIE") != -1 ||
    !!document.DOCUMENT_NODE == true
  ) {
    //IF IE > 10

    browser_name = "IE";
    browser_version = `v${navigator.userAgent.split("MSIE/")[1]}`;
  } 
  data = {
    browserName: browser_name,
    browserVersion: browser_version,
    OSName: OS_name
  }
  return data
  
};

export type dataType = {
  browserName: string;
  browserVersion: string;
  OSName: string;
};
